import { jsx as _jsx } from "react/jsx-runtime";
/**
 * Copyright (c) Selfcity, Inc.
 * All rights reserved.
 */
import React from "react";
function TechChoiceModal({ token, clientRequestId, onSiteJobId, onClose, height = '800px', }) {
    const iframe = React.useRef(null);
    React.useEffect(() => {
        if (iframe.current !== null) {
            setTimeout(() => {
                window.addEventListener("message", (event) => {
                    if (event.data === 'CLOSE_MODAL') {
                        onClose();
                        window.location.reload();
                    }
                }, false);
                iframe.current.contentWindow.postMessage("INIT", "*");
            }, 2000);
        }
    }, []);
    return (_jsx("div", { className: "on-site-job-modal flex flex-col items-stretch vgap-3", style: { height }, children: _jsx("iframe", { ref: iframe, src: global.NEW_APP_URL + `/agenda?token=${token}`, style: { border: 'none', height: '100%' } }, onSiteJobId) }));
}
export default React.memo(TechChoiceModal);
